import {useState,useEffect} from 'react'
import {useSelector,useDispatch} from 'react-redux'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import InputGroup from 'react-bootstrap/InputGroup'
import Tooltip from 'react-bootstrap/Tooltip'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'

import Select from 'react-select'

import {
	deactivateSubscriptionPrice,
	selectAvailableSubscriptionById,
	updateSubscription,
	createSubscription,
	setActiveComponent,
	setEditor
} from './availableSubscriptionsSlice'

import useS3DirectUpload from '../../../hooks/useS3DirectUpload'

import useApiStatusDispatch from '../../../hooks/useApiStatusDispatch'
import PriceOption from './PriceOption'
import {selectAcceptedCurrency} from '../../settings/settingsSlice'
import {getCurrencySymbol} from '../../../util/intl'

import {
	useCustomForms
} from '../../customForms/hooks'

import {
	useRefreshPurchaseFormsTree,
} from '../hooks'

const Creator = () => {
	const dispatch = useDispatch()
	const statusDispatch = useApiStatusDispatch()
	const id = useSelector(state=>state.availableSubscriptions.editor.id)
	const isNew = !Boolean(id)
	const currency = useSelector(selectAcceptedCurrency)

	const {processUpload} = useS3DirectUpload()

	const {status:formsStatus,forms} = useCustomForms()
	const refreshPurchaseFormsTree = useRefreshPurchaseFormsTree()


	const [status,setStatus] = useState('idle')
	//if subscrition id is set then get the subscription from the state
	const subscription = useSelector(state=>isNew?false:selectAvailableSubscriptionById(state,id))
	const [name,setName] = useState('')
	const [notes,setNotes] = useState('')
	const [image,setImage] = useState(null)
	const [isActive,setIsActive] = useState(false)
	const [useSessionCredits,setUseSessionCredits] = useState(false)
	const [sessionCredits,setSessionCredits] = useState(0)
	const [hasPrice,setHasPrice] = useState(false)
	const [interval,setInterval] = useState('month')
	const [intervalCount,setIntervalCount] = useState(1)
	const [dollarAmount,setDollarAmount] = useState('')

	const [removePrice, setRemovePrice] = useState(false)

	const [selectedForms,setSelectedForms] = useState([])


	const closeEditor = ()=>{
		dispatch(setActiveComponent('subscriptions'))
	}

	const handleCreateSubscription = async ()=>{
		setStatus('pending')
		const price = {
			recurring:{
				interval_count:intervalCount,
				interval
			},
			dollar_amount:dollarAmount,
		}
		const payload = {
			session_credits:useSessionCredits?sessionCredits:0,
			is_active:isActive?1:0,
			form_ids:selectedForms.map(f=>f.value),
			price,
			notes,
			name,
		}
		if(image){
			const s3Res = await processUpload(image)
			payload.image = s3Res.payload.url
		}
		statusDispatch(
			createSubscription(payload),
			'subscription',
			'create'
		).then(action=>{
			setStatus('idle')
			if(action.payload.success==='1'){
				closeEditor()
				refreshPurchaseFormsTree()
			}
		})
	}


	const validate = ()=>{
		const needed = []
		if(!name) needed.push('subscription name')
		if(!dollarAmount) needed.push('price')
		if(!intervalCount) needed.push('payment frequency')
		return needed
	}

	
	const needed = validate()

	return (
		<div id="containerDiv">
			<div className="bg-white p-3 mt-2 border rounded">
				<strong style={{lineHeight:'1.5'}}>
					Create Subscription
				</strong>
				<hr className="my-1"/>
				<label>Subscription Name</label>
				<Form.Control
					onChange={e=>{setName(e.target.value)}}
					value={name}
				/>
				<label>Subscription Image</label>
				<Form.File
					onChange={e=>{setImage(e.target.files[0])}}
					custom
					id="create-subscription-image-input"
					label="Subscription Image"
				/>
				{Boolean(image)&&
					<div>
						<img 
							className="rounded mb-2"
							src={window.URL.createObjectURL(image)} 
							style={{width:'300px',maxWidth:'100%',display:'block'}}
						/>
						<Button 
							onClick={()=>{ setImage(null) }}
							variant="link" 
							className="text-danger"
						>
							Remove Image
						</Button>
					</div>
				}
				<label>Subscription Notes</label>
				<Form.Control 
					onChange={e=>{setNotes(e.target.value)}}
					as="textarea"
					value={notes}
				/>
				<Form.Switch 
					label="Active"
					onChange={e=>{
						setIsActive(e.target.checked)
					}}
					checked={isActive}
					id="is-active"
				/>
				<div>
					<div>Pricing</div>
					<InputGroup>
						<InputGroup.Prepend>
							<InputGroup.Text>
								{getCurrencySymbol(currency?.ISO)}
							</InputGroup.Text>
						</InputGroup.Prepend>
						<Form.Control 
							onChange={e=>{
								setDollarAmount(e.target.value)
							}}
							placeholder={`XX.XX (${currency?.ISO})`} 
							value={dollarAmount}
						/>
						<InputGroup.Text style={{borderRadius:0,borderLeft:'none',borderRight:'none'}}>
							every
						</InputGroup.Text>
						<Form.Control 
							onChange={e=>{
								setIntervalCount(e.target.value)
							}}
							value={intervalCount}
						/>
						<Form.Control 
							onChange={e=>{
								setInterval(e.target.value)
							}}
							value={interval}
							as="select"
						>
							<option value="day">day(s)</option>
							<option value="week">week(s)</option>
							<option value="month">month(s)</option>
							<option value="year">year(s)</option>
						</Form.Control>
					</InputGroup>
					<small className="text-muted">Example: $340 every 2 months</small>
				</div>
				<Form.Check 
					onChange={e=>{
						setUseSessionCredits(e.target.checked)
					}}
					label="Use session credits" 
					checked={useSessionCredits}
					id="session-credits"
				/>
				{useSessionCredits&&
					<>
						<label>Session Credits</label> 
						<Form.Control
							onChange={e=>{
								setSessionCredits(e.target.value)
							}}
							placeholder="# of Session Credits"
							value={sessionCredits}
						/>
					</>
				}
				<label>Forms & Waivers</label>
				<Select 
					onChange={(selectedForms)=>{
						setSelectedForms(selectedForms)
					}}
					value={selectedForms}
					options={
						forms.map(
							form => ({
								value:form.form_id,
								label:form.form_title
							})
						)//end map
					}//end options
					isMulti
				/>
				<div className="text-right mt-3">
					<Button className="mr-2" size="sm" onClick={closeEditor} variant="outline-danger">
						Cancel
					</Button>
					{
						needed.length>0?
						<div className="text-primary">
							Please provide: {needed.join(', ')}
						</div>
						:
						<Button size="sm" 
							disabled={status==='pending'}
							variant="outline-success" 
							onClick={handleCreateSubscription}
						>
							Create
							{status==='pending'&&<Spinner className="ml-1" animation="border" size="sm"/>}
						</Button>
					}
				</div>
			</div>
		</div>
	)
}

export default Creator